<!--
해외주문 > 주문하기 (상품선택) 페이지에서 사용되는 상품의 일괄작업
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
------------------------------------
-->
<template>
    <div
        class="wrapper"
        :uk-sticky="onSticky && itemCheckedCount > 0"
    >
        <div class="uk-flex uk-flex-between uk-flex-bottom">
            <button
                class="uk-button uk-button-primary uk-margin-right"
                type="button"
                :disabled="disabled"

                @click="$refs['order'].jobInit()"
            >
                <i class="material-icons">edit</i>
                선택상품 주문하기
            </button>

            <!-- 선택개수안내 -->
            <div class="selected-msg" v-show="itemCheckedCount > 0" v-html="itemCheckedInfo"></div>

            <!-- 선택된 아이템 없음 -->
            <div class="no-selected-msg" v-show="itemCheckedCount === 0">
                {{ batch.item_checked_nothing_msg }}
            </div>

            <div class="uk-width-expand"></div>

            <button
                class="uk-button uk-button-small uk-button-danger uk-margin-right"
                type="button"
                :disabled="disabled"
                title="선택한 상품을 상품품절 단계로 설정합니다"

                @click="$refs['vd-out-stock'].jobInit()"
            >
                <i class="material-icons">label</i>
                상품품절
            </button>

            <button
                class="uk-button uk-button-small uk-button-danger uk-margin-right"
                type="button"
                :disabled="disabled"
                title="선택한 상품을 주문보류 단계로 설정합니다"

                @click="$refs['vd-order-hold'].jobInit()"
            >
                <i class="material-icons">label</i>
                주문보류
            </button>

            <button
                class="uk-button uk-button-small uk-button-danger"
                type="button"
                :disabled="disabled"
                title="선택한 상품을 배송취소 단계로 설정합니다"

                @click="$refs['cancel'].jobInit()"
            >
                <i class="material-icons">label</i>
                배송취소
            </button>

        </div>


        <!-- 주문하기 기능 -->
        <order
            ref="order"
            :batch="batch"
            :csrfToken="csrfToken"
            :region-currency="regionCurrency"
            :region-id="regionId"
            :agent-id="agentId"
            :user-id="userId"
        ></order>

        <!-- 상품품절 기능 -->
        <vd-out-stock
            ref="vd-out-stock"
            :batch="batch"
            :csrfToken="csrfToken"
        ></vd-out-stock>



        <!-- 주문보류 기능 -->
        <vd-order-hold
            ref="vd-order-hold"
            :batch="batch"
            :csrfToken="csrfToken"
        ></vd-order-hold>

        <!-- 배송취소 기능 -->
        <cancel
            ref="cancel"
            :batch="batch"
            :csrfToken="csrfToken"
        ></cancel>

    </div>

</template>

<script>
    import checkedCountable from '../../checked-countable';
    import stickiable from '../../stickable';

    export default {
        mixins: [
            checkedCountable,
            stickiable,
        ],
        components: {
            'order': require('./order.vue').default,
            'vd-out-stock': require('../prod/vd-out-stock.vue').default,
            'vd-order-hold': require('../prod/vd-order-hold.vue').default,
            'cancel': require('../prod/cancel.vue').default,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

            // 지역화폐
            regionCurrency: String,

            // 지역ID
            regionId: Number,

            // 영업소ID
            agentId: Number,

            // 사용자ID
            userId: Number,
        },
        data: function () {

            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.5rem;
    }

</style>